import { DateTime } from "luxon"

const useTimeZoneConverter = () => {
	// because the semi design date picker use the date-fns library, the date object will be a string.
	// and I have to convert it use its prototype function valueOf() to get the 13 digits number.
	// then use the new Date() to convert it to the Luxon Date object.
	// finally, use the setZone("utc") to convert it to the UTC time zone.
	// notice that the keepLocalTime option should not be set to true, so the time will be convert to UTC time.
	const convertToServerTimeZone = (date) => {
		return DateTime.fromMillis(date.valueOf())
			.setZone("utc")
			.toISO()
	}

	// convert the date to the browser time zone.
	// the date is the string from the server, which is the UTC time zone as ISO format.
	// fromISO() will convert the string to the DateTime object with the UTC time zone.
	// then use the setZone() to convert it to the browser time zone.
	// finally, use the toLocaleString() to convert it to the custom string.
	const convertToBrowserTimeZone = (date) =>
		DateTime
			.fromISO(date, { zone: "utc" })
			.setZone(DateTime.local().zoneName)
			.toLocaleString({ ...DateTime.DATE_MED_WITH_WEEKDAY, ...DateTime.TIME_24_WITH_SECONDS })

	return { convertToBrowserTimeZone, convertToServerTimeZone }
}

export default useTimeZoneConverter